module.exports = __webpack_public_path__ + "img/night-middle-bg_ms.09c993ae.png";